const dispatchHistory = {}
const productBlockSelector = '.product-block'
const mutatingElementSelector = '.filter-container'
const collectionListingClass = 'collection-listing'

const utils = {
    getPosition: function (product) {
        const products = [...document.querySelectorAll(productBlockSelector)];
        const position = products.findIndex(otherProduct => otherProduct.dataset.productId === product.dataset.productId)
        return position + 1;
    },
    getPrice: function (price) {
        const regex = /\d+\.\d{2}/;
        return regex.exec(price)[0];
    },
    getCollection: function () {
        const url = window.location.href.split("/collections/")[1].split('?')[0];
        return `/collections/${url}`
    },
    getFilterParams: function () {
        const url = window.location.href.split("?")[1];
        return url || "";
    },
    getVariant: function (product) {
        return product.dataset.variantNumber !== "1" ? product.dataset.variantName : null;
    },
    pushToDataLayer: function (obj, clearPrev = true) {
        if (clearPrev) window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(obj);
    },
    getProductData: function (product) {
        const obj = {
            name: product.dataset.productName,
            id: product.dataset.productId,
            price: this.getPrice(product.dataset.productPrice),
            brand: "Letterfest",
            category: product.dataset.productCategory,
            variant: this.getVariant(product),
            list: this.getCollection(),
            position: this.getPosition(product)
        }
        return obj;
    }
}

const handleProductView = (entries) => {

    if (!entries.length === 0) return;

    const impressions = entries.map(entry => {
        const product = entry.target;
        const { name, id, price, brand, category, variant, list, position } = utils.getProductData(product)

        const impression = {
            name,
            id,
            price,
            brand,
            category,
            list,
            position
        }
        if (variant) {
            impression['variant'] = variant;
            impression['name'] = `${name} - ${variant}`
        }
        return impression;
    });

    const obj = {
        'event': 'gaEventTrigger_EE',
        'gaEventCategory': 'Shopify (Swanky)',
        'gaEventAction': 'view_item_list',
        'gaEventLabel': utils.getFilterParams(),
        'ecommerce': {
            'impressions': impressions
        }
    }
    utils.pushToDataLayer(obj)
}
const createProductObserver = () => {

    const handleIntersect = (entries, observer) => {
        const intersectingProducts = entries.filter(entry => {
            return entry.isIntersecting;
        })
        intersectingProducts.forEach(entry => {
            const product = entry.target;
            observer.unobserve(product);
            dispatchHistory[product.dataset.productId] = true;
        })
        handleProductView(intersectingProducts)
    }

    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.8
    }

    return new IntersectionObserver(handleIntersect, options);
}
const observeProducts = (products, observer) => {
    products.filter(product => !dispatchHistory[product.dataset.productId]).forEach(product => {
        observer.observe(product);
    })
}

const handleProductClick = (product) => {
    const { name, id, price, brand, category, variant, position, list } = utils.getProductData(product);

    const impression = {
        name,
        id,
        price,
        brand,
        category,
        position
    }
    if (variant) {
        impression['variant'] = variant;
        impression['name'] = `${name} - ${variant}`
    }
    const obj = {
        'event': 'gaEventTrigger_EE',
        'gaEventCategory': 'Shopify (Swanky)',
        'gaEventAction': 'click_product',
        'ecommerce': {
            'click': {
                'actionField': { 'list': list },
                'products': [impression]
            }
        }
    }
    utils.pushToDataLayer(obj)
}
const addClickHandlers = (products) => {
    products.forEach(product => {
        product.addEventListener('click', () => {
            handleProductClick(product);
        })
    })
}
const products = [...document.querySelectorAll(productBlockSelector)];
const productObserver = createProductObserver();
addClickHandlers(products);
observeProducts(products, productObserver)


const createCollectionObserver = () => {
    const handleMutations = (mutationsList, observer) => {
        mutationsList.forEach(mutation => {
            if (mutation.type != "childList") return;
            const addedEles = [...mutation.addedNodes];
            const collectionListing = addedEles.filter(ele => ele.classList?.contains(collectionListingClass))[0];
            const products = [...collectionListing.querySelectorAll(productBlockSelector)];
            addClickHandlers(products);
            observeProducts(products, productObserver);
        })
    }

    return new MutationObserver(handleMutations)
}

const observeCollection = (collection, observer) => {
    const options = {
        subtree: true,
        childList: true
    }
    observer.observe(collection, options)
}

const collection = document.querySelector(mutatingElementSelector);
const collectionObserver = createCollectionObserver();
observeCollection(collection, collectionObserver)
